var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _circle7, _circle8, _circle9, _circle10, _path5, _path6, _circle11, _path7, _path8, _path9, _circle12, _circle13, _circle14, _path10, _path11, _circle15, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotifHeader2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 278,
    viewBox: "0 0 245 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 0 0 -1 157 74)",
    fill: "#143162"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 0 0 -1 157 50)",
    fill: "#0052A4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 0 0 -1 109 74)",
    fill: "#0052A4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 0 0 -1 181 26)",
    fill: "#66DDC0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(1 0 0 -1 181 2)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(1 0 0 -1 243 74)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181 62C174.373 62 169 67.3726 169 74C169 80.6274 174.373 86 181 86L205 86C211.628 86 217 80.6274 217 74C217 67.3726 211.628 62 205 62L181 62Z",
    fill: "#66DDC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 158C5.37258 158 -2.34843e-07 163.373 -5.24537e-07 170C-8.1423e-07 176.627 5.37258 182 12 182L36 182C42.6274 182 48 176.627 48 170C48 163.373 42.6274 158 36 158L12 158Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217 26C217 19.3726 211.627 14 205 14C198.373 14 193 19.3726 193 26L193 50C193 56.6274 198.373 62 205 62C211.627 62 217 56.6274 217 50L217 26Z",
    fill: "#143162"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217 38L193 38L193 50C193 56.6274 198.373 62 205 62C211.627 62 217 56.6274 217 50L217 38Z",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 157 218)",
    fill: "#143162"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 157 194)",
    fill: "#0052A4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 157 146)",
    fill: "#0052A4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 181 170)",
    fill: "#66DDC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181 206C174.373 206 169 211.373 169 218C169 224.627 174.373 230 181 230L205 230C211.627 230 217 224.627 217 218C217 211.373 211.627 206 205 206L181 206Z",
    fill: "#66DDC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157 110C150.373 110 145 115.373 145 122C145 128.627 150.373 134 157 134L181 134C187.627 134 193 128.627 193 122C193 115.373 187.627 110 181 110L157 110Z",
    fill: "#DDE2E9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 229 122)",
    fill: "#0052A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217 170C217 163.373 211.627 158 205 158C198.373 158 193 163.373 193 170V194C193 200.627 198.373 206 205 206C211.627 206 217 200.627 217 194V170Z",
    fill: "#143162"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217 182H193V194C193 200.627 198.373 206 205 206C211.627 206 217 200.627 217 194V182Z",
    fill: "#DDE2E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0001 278C78.3727 278 73.0001 272.627 73.0001 266C73.0001 259.373 78.3727 254 85.0001 254L109 254C115.628 254 121 259.373 121 266C121 272.627 115.628 278 109 278L85.0001 278Z",
    fill: "#66DDC0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 146,
    r: 12,
    fill: "#0052A4"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 194,
    r: 12,
    fill: "#0052A4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 170,
    r: 12,
    fill: "#66DDC0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85 134C78.3726 134 73 128.627 73 122C73 115.373 78.3726 110 85 110L109 110C115.627 110 121 115.373 121 122C121 128.627 115.627 134 109 134L85 134Z",
    fill: "#143162"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61 230C54.3726 230 49 224.627 49 218C49 211.373 54.3726 206 61 206L85 206C91.6274 206 97 211.373 97 218C97 224.627 91.6274 230 85 230L61 230Z",
    fill: "#DDE2E9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 218,
    r: 12,
    fill: "#0052A4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121 170C121 176.627 115.627 182 109 182C102.373 182 97 176.627 97 170V146C97 139.373 102.373 134 109 134C115.627 134 121 139.373 121 146V170Z",
    fill: "#143162"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121 158H97V146C97 139.373 102.373 134 109 134C115.627 134 121 139.373 121 146V158Z",
    fill: "#DDE2E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotifHeader2);
export default __webpack_public_path__ + "static/media/motif-header-2.3adf0ab42b607abeffa19b9691b71db9.svg";
export { ForwardRef as ReactComponent };